//
//
//
//
//
//
//
//

/*禁止滚动和开启滚动*/
import {NoScroll, Scroll} from '@js/public/animation'
export default {
  name: 'AllScreenDialog',
  props: ['show', 'close'], // close代表是否显示关闭按钮，show暂时不用
  data () {
    return {
    }
  },
  methods: {
    /*关闭时，通知父组件*/
    closeme () {
      this.$emit('close', 'data')
      this.toBack()
      Scroll()
    }
  },
  mounted () {
    // NoScroll()
  },
  created () {
  },
  destroyed () {
    // Scroll()
  }
}



// WEBPACK FOOTER //
// ./src/components/publicComponents/allScreenDialog.vue